import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GetCUPCosNoList } from 'src/app/_Models/AD/ADCUP/ADCUP0499ISU01/getCUPCosNoList';
import { GetCUPCosSerialNoList } from 'src/app/_Models/AD/ADCUP/ADCUP0499ISU02/getCUPCosSerialNoList';
import { GetEduList } from 'src/app/_Models/getEduList';
import { GetSelectList } from 'src/app/_Models/getSelectList';
import { SystemService } from 'src/app/_Services/_Shared/system.service';
import { environment } from 'src/assets/environments/environment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-ADCUP0499ISU02',
    templateUrl: './ADCUP0499ISU02.component.html',
    styleUrls: ['./ADCUP0499ISU02.component.css']
})
export class ADCUP0499ISU02Component implements OnInit {
    baseUrl = environment.apiUrl;
    modalRef!: BsModalRef;
    eduList!: GetEduList[];
    deptList!: GetSelectList[];
    cosnoList!:GetCUPCosNoList[];
    thisCosnoLis!:GetCUPCosNoList;
    cosserialnoList!:GetCUPCosSerialNoList[];
    thisCosSerialNo!:GetCUPCosSerialNoList;

    ngFormInput = new UntypedFormGroup({
        EduNo: new UntypedFormControl(''),
        DeptNo: new UntypedFormControl(''),
        KeyWord: new UntypedFormControl('')
    });

    ngForm = new UntypedFormGroup({
        DataKey: new UntypedFormControl(''),
        CosSerialNo: new UntypedFormControl(''),
        CosNo: new UntypedFormControl(''),
        CosName: new UntypedFormControl(''),
        EduNo: new UntypedFormControl(''),
        DeptNo: new UntypedFormControl(''),
        SerialNo: new UntypedFormControl(''),
        Memo: new UntypedFormControl(''),
        UpdateUser: new UntypedFormControl(''),
        UpdateDate: new UntypedFormControl('')
    });

    ngFormCosNoInput = new UntypedFormGroup({
        DeptNo: new UntypedFormControl(''),
        KeyWord: new UntypedFormControl('')
    });

    constructor(private http: HttpClient,
        private toastr: ToastrService,
        private systemService: SystemService,
        private modalService: BsModalService){}

    ngOnInit(): void {
        this.getEduList();
        this.getDeptList();
    }

    getEduList() {
        this.systemService.getEduList('', '', '', 'Y').subscribe((response) => {
            this.eduList = response;
        }, error => this.toastr.error(error.error))
    }

    getDeptList() {
        this.deptList=[];
        this.http.get<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU01/Get_CUP_ISU01_DeptNo").subscribe((response => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.deptList = response;
        }));
    }

    getCUPCosSerialNoList(){
        this.cosserialnoList=[];
        this.http.post<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU02/Get_CUP_ISU02_List",this.ngFormInput.value).subscribe((response => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.cosserialnoList = response;
        }));
    }

    getCUPCosSerialNoDetail(thisItem:GetCUPCosSerialNoList){
        this.thisCosSerialNo=thisItem;
        this.http.post<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU02/Get_CUP_ISU02_Detail", thisItem).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.ngForm.setValue(response);
        })
    }

    getCUPCosSerialNoDetailSave(){
        if (!this.ngForm.valid) {
            this.toastr.info("請檢查欄位正確或填寫完畢")
            return;
        }

        if(this.ngForm.get("CosNo")?.value!=""){
            this.ngForm.get("DeptNo")?.setValue(this.ngForm.get("CosNo")?.value.substring(0,2));
        }

        if(this.ngForm.get("Memo")?.value==null){
            this.ngForm.get("Memo")?.setValue("");
        }

        if(this.ngForm.get("CosSerialNo")?.value==null){
            this.ngForm.get("CosSerialNo")?.setValue("");
        }

        if(this.ngForm.get("SerialNo")?.value==null){
            this.ngForm.get("SerialNo")?.setValue("");
        }

        if(this.ngForm.get("DataKey")?.value==null){
            this.ngForm.get("DataKey")?.setValue("");
        }

        if(this.ngForm.get("UpdateUser")?.value==null){
            this.ngForm.get("UpdateUser")?.setValue("");
        }

        if(this.ngForm.get("UpdateDate")?.value==null){
            this.ngForm.get("UpdateDate")?.setValue("");
        }

        this.http.post<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU02/Get_CUP_ISU02_Save", this.ngForm.value).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.toastr.success("儲存成功");
            if(this.ngForm.get("DataKey")?.value==""){
                this.ngForm.reset();
            }
        })
    }

    getCUPCosSerialNoDelete(){
        if (this.ngForm.get('DataKey')?.value == '') {
            this.toastr.info("請選擇項目");
            return;
        }

        Swal.fire({
            title: "確定刪除？",
            showCancelButton: true,
            cancelButtonText: "取消",
            showConfirmButton: true,
            confirmButtonText: "確定",
        }).then(result => {
            if (result.isConfirmed) {
                this.http.post<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU02/Get_CUP_ISU02_Delete", this.thisCosSerialNo).subscribe((response) => {
                    if (response.Info == false) {
                        this.toastr.warning(response.Message);
                        return;
                    }
                    this.toastr.success("刪除成功");
                    this.ngForm.reset();
                    this.getCUPCosSerialNoList();
                })
            }
            else {
                this.toastr.info("動作已取消");
            }
        })
    }

    getCUPCosNoList(){
        this.cosnoList=[];
        this.http.post<any>(this.baseUrl + "ACAD/CUP/ADCUP0499ISU01/Get_CUP_ISU01_List",this.ngFormCosNoInput.value).subscribe((response => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.cosnoList = response;
        }));
    }

    openModal(template: TemplateRef<any>){
        let modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-xl'
        };
        this.modalRef = this.modalService.show(template, modalConfig);
    }

    setCos(CosNo: string, CosName: string) {
        this.ngForm.get('CosNo')?.setValue(CosNo);
        this.ngForm.get('CosName')?.setValue(CosName);
        this.modalRef.hide();
    }
}
